(function(){
    'use strict';

    angular
    .module('appback')
    .controller('MicrobiologiaController', MicrobiologiaController)
 
    MicrobiologiaController.$inject = ["socket","GenerallabService","MicrobiologiaService","$http","$timeout","$uibModal", "$log", "$document","$sce", "$window"];
              
    function MicrobiologiaController(socket,GenerallabService,MicrobiologiaService,$http,$timeout,$uibModal, $log, $document,$sce, $window)
    {                         
        var vm = this; 
        vm.lecturas = {};
        vm.generalLab = GenerallabService;
        vm.modalesAbiertos = [];
        vm.estadoTareas = {};

        vm.reloadPage = function() {
            $window.location.reload();
        };

        vm.getLecturasByPeticionIdAnaliticaId = function($event,peticion_id,analitica_id,resembrado_id=false, medios_resiembra=false, microorganismo_aislado=false){
            MicrobiologiaService.getLecturasByPeticionIdAnaliticaId(peticion_id,analitica_id, resembrado_id, function(data){
                console.log("get LECTURAS data", data);
                var modalInstance = vm.openLecturasModal($event, data.lecturas, data.peticion, data.analitica, data.sembrado, peticion_id, analitica_id, resembrado_id, medios_resiembra, microorganismo_aislado);
                vm.modalesAbiertos.push(modalInstance);
            });
        }

        vm.openLecturasModal = function($event, lecturas, peticion, analitica, sembrado, peticion_id, analitica_id, resembrado_id=false, medios_resiembra=false, microorganismo_aislado=false){
            if(angular.isDefined($event)){
                $event.stopPropagation();
                $event.preventDefault();
            }
            var popup = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title-top',
                ariaDescribedBy: 'modal-body-top',
                templateUrl: '/backend/resultadopeticion/templateresultados?name=lecturas.twig',
                size: 'full',
                controller: function($scope, $uibModalInstance, MicrobiologiaService) {
                    if(vm.generalLab.lecturas.length > 0){
                        vm.generalLab.lecturas_array.push(angular.copy(vm.generalLab.lecturas));
                    }
                    $scope.lc = vm;
                    $scope.generalLab = vm.generalLab;
                    $scope.generalLab.lecturas = lecturas;
                    $scope.peticion_id = peticion_id;
                    $scope.peticion = peticion;
                    $scope.analitica = analitica;
                    $scope.analitica_id = analitica_id;
                    $scope.sembrado = sembrado;
                    $scope.resembrado_id = resembrado_id;
                    $scope.lc.resembrado_id = resembrado_id;
                    $scope.medios_resiembra = medios_resiembra;
                    $scope.microorganismo_aislado = microorganismo_aislado;

                    console.log("LECTURAS RECIBIDAS", $scope.generalLab.lecturas);

                    $scope.reabrirLectura = function($event){
                        MicrobiologiaService.reabrirLectura($scope.peticion_id, $scope.analitica_id, function(data){
                            console.log("Reabriendo lectura", data);
                            if(data.code>0){
                                $scope.sembrado = data.sembrado;
                                vm.lecturas[$scope.peticion_id][$scope.analitica_id].finalizada = 0;
                            }        
                        })
                    }

                    $scope.okForm = function(){
                        MicrobiologiaService.finalizarLecturaPeticionAnalitica($scope.peticion_id, $scope.analitica_id, function(data){
                            console.log("Resultado finalizado", data);
                            if(data.code>0){
                                vm.modalesAbiertos.forEach(function(modal) {
                                    if (modal && typeof modal.close === 'function') {
                                        modal.close();
                                    }
                                });
                                vm.modalesAbiertos = [];
                                vm.lecturas[$scope.peticion_id][$scope.analitica_id].finalizada = 1;
                            }else{
                                console.log("Error al finalizar lectura", data);
                            }
                        });
                    }
                    $scope.koForm = function(){
                        console.log("actualizando lecturas", $scope.generalLab.lecturas_array);
                        if ($scope.generalLab.lecturas_array.length > 0) {
                            $scope.generalLab.lecturas = $scope.generalLab.lecturas_array.pop();
                        }else {
                            $scope.generalLab.lecturas = [];
                        }
                        console.log("Modal cerrado, lecturas actualizadas:", $scope.generalLab.lecturas);
                        $uibModalInstance.close();
                    }
                }
            });
            return popup;
        }

        vm.changeEstadoTarea = function($event,aislado_id,tarea){
            console.log("CHANGE ESTADO TAREA AISLADO", aislado_id, tarea);
            MicrobiologiaService.changeEstadoTarea(aislado_id, tarea, function(data){
                console.log("Cambio de estado de tarea", data);
                //vm.reloadPage();
            });
        }

        vm.malditofs = { pendientes: { dragging: false, items:[] } };
        vm.placas = [];
        vm.posPlaca = 96;
        vm.startIndexRand = 0;
        vm.filtros = { buscador: "", user_pendientes: "", fecha_placas:""};

        vm.buscarMaldisIni = function(){
            MicrobiologiaService.getPlacasMalditof(vm.filtros.fecha_placas, function(data){
                console.log("malditof data", data);
                vm.placas = data.placas;
                vm.filtros.user_pendientes = data.user_id.toString();
                vm.buscarPend();
            })
        }

        vm.filterFechaPlacas = function(){
            MicrobiologiaService.getPlacasMalditof(vm.filtros.fecha_placas, function(data){
                console.log("malditof data", data);
                vm.placas = data.placas;
            })
        }

        vm.buscarPend = function(){
            console.log("buscando pendientes", vm.placas, vm.filtros);
            MicrobiologiaService.getMalditofsPend(vm.filtros.buscador, vm.filtros.user_pendientes, vm.placas, function(data){
                console.log("malditof data", data);
                vm.malditofs.pendientes.items = data.malditofs_pendientes;
            })
        }

        vm.addPlaca = function(){
            MicrobiologiaService.addNewPlaca(function(data){
                console.log("new placa", data);
                vm.placas = data.placas;

                $timeout(vm.scrollPlaca(vm.placas.length - 1));
            });
        }

        vm.countRellenas = function(placa){
            var cont = 0;
            for(var i=0;i<placa.items.length;i++){
                if(placa.items[i].elemento != null && placa.items[i].elemento.id){
                    cont++;
                }
            }
            return cont;
        }

        vm.guardarPlaca = function(placa, placaIndex){
            console.log("guardando placa", placa);
            MicrobiologiaService.guardarPlaca(placa, function(data){
                console.log("return guardar placa", data);
                if(data.code > 0){
                    vm.placas = data.placas;
                    $timeout(vm.scrollPlaca(placaIndex));
                } else {
                    console.log("Error al guardar placa.");
                }
            }) 
        }

        vm.generarFichero = function(placa){
            console.log("generando fichero para la placa", placa);
            MicrobiologiaService.generarFichero(placa, function(data){
                if(data.filename){
                    window.location.href = '/backend/microbiologia/descargarplaca?filename=' + encodeURIComponent(data.filename);
                    placa.fichero_disponible = 0;
                }    
            });
        }

        vm.cerrarPlaca = function(placa){
            console.log("guardando placa", placa);
            MicrobiologiaService.guardarPlaca(placa, function(data){
                console.log("return guardar placa", data);
                if(data.code > 0){
                    MicrobiologiaService.generarFichero(placa, function(data){
                        MicrobiologiaService.cerrarPlaca(placa, function(dataIn){
                            if(dataIn.code > 0){
                                vm.placas = dataIn.placas;
                            }
                        })    
                    });
                } else {
                    console.log("Error al guardar placa.");
                }
            }) 
        }

        vm.getRand = function(placa_index, pos_index){
            console.log("GET RAND", placa_index, pos_index);
            let placa = vm.placas[placa_index];
	    	for(var cont=pos_index;cont< vm.posPlaca && vm.malditofs.pendientes.items.length>0;cont++){
		        if(!placa.items[cont].elemento.lims_id){
			        placa.items[cont].elemento = vm.malditofs.pendientes.items[0];
                    placa.items[cont].elemento.added = true;
			        vm.malditofs.pendientes.items.splice(0,1);
		    	}
		    }
            console.log("PLACAS GET RAND", vm.placas);
	    }

        vm.changeSelect = function(item,index){
            console.log("placSelected changeSelect", item, index);
	    	if(vm.placSelected && !vm.placSelected.finalizada && !vm.selected.id){
	    		for(var cont=0;cont<vm.placSelected.items.length;cont++){
	    			if(vm.placSelected.items[cont] == vm.selected){
	    				vm.placSelected.items[cont].elemento = item;
	    				vm.placSelected.items[cont].elemento.added = true;
		    			vm.malditofs.pendientes.items.splice(index,1);
	    			}
	    		}
	    	}
            console.log("PLACAS", vm.placas);
	    }

        vm.borrarPendiente = function(list,index){
	    	vm.malditofs.pendientes.items.push(list.items[index].elemento);
		    list.items[index].elemento = {};
	        vm.selected = list.items[index];
	        vm.placSelected = list;
	        list.items[index].elemento.selected = true;
	    }

        vm.scrollPlaca = function(placaIndex){
            var placaId = 'placa_' + placaIndex;
                        
            $timeout(function() {
                var modalBody = $('#maldis-placas');
                var nuevaPlaca = $("#"+placaId);
                
                if (modalBody && nuevaPlaca) {
                    console.log("Scroll to top of modal", modalBody, nuevaPlaca);
                    var topPos = nuevaPlaca.offset().top - modalBody.offset().top + modalBody.scrollTop();

                    console.log(topPos);
                    modalBody.animate({
                        scrollTop: topPos
                      }, 500);
                }
            }, 0);
        }
    }
})();